import { Action as BrandsAction } from '../actions/brands';
import { mergeReducer } from '../../lib/utils';

const defaultState = {
  isFetchingAllBrands: false,
  brandsById: {},
  error: undefined,
};

export default function brandsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case BrandsAction.Brands.BrandsCompleted:
      return {
        ...state,
        isFetchingAllBrands: false,
        brandsById: {
          ...state.brandsById,
          ...body.brands.reduce(mergeReducer('brand_id'), {}),
        },
        allBrandsLoaded: body.allBrandsLoaded,
      };

    case BrandsAction.Brands.BrandsFailed:
      return {
        ...state,
        isFetchingAllBrands: false,
        error: body,
      };

    case BrandsAction.Brands.BrandsPending:
      return {
        ...state,
        error: undefined,
        isFetchingAllBrands: true,
      };

    default:
      return state;
  }
}
